import React from "react";

const StripedProgressBar = ({
  value = 40,
  height = 12,
  color = "#4f46e5",
  bg = "#e5e7eb"
}) => {
  return (
    <div
      className="progress-container"
      style={{ height, backgroundColor: bg }}
    >
      <div
        className="progress-bar striped animated"
        style={{
          width: `${value}%`,
          backgroundColor: color
        }}
      />
      <style>{`.progress-container {
  width: 100%;
  border-radius: 999px;margin-top:10px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  transition: width 0.6s ease;
  border-radius: 999px;
  position: relative;
}

/* Stripes */
.striped {
  background-image: linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.25) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.25) 50%,
    rgba(255, 255, 255, 0.25) 75%,
    transparent 75%,
    transparent
  );
  background-size: 40px 40px;
}

/* Animation */
.animated {
  animation: moveStripes 1s linear infinite;
}

@keyframes moveStripes {
  from {
    background-position: 0 0;
  }
  to {
    background-position: 40px 0;
  }
}
`}</style>
    </div>
  );
};

export default StripedProgressBar;
